import styled from 'styled-components';
export const StyledCardWrapper = styled.div`
  background-color: ${({
  theme
}) => theme.colors.background.secondaryLighter};
  border-radius: ${({
  theme
}) => theme.radius.small};
  padding: 2.4rem;
  margin: 4rem 0 4.8rem;
  text-align: start;
  
  h3[data-type='room-title'] {
    font-size: ${({
  theme
}) => theme.fonts.sizes.medium};
    text-transform: capitalize;    
    margin-bottom: 2.4rem;
   
    
    svg {
      margin-right: 0.8rem;
      color: ${({
  theme
}) => theme.colors.text.light};
    }
  }

  @media (max-width: ${({
  theme
}) => theme.sizes.md}) {
    margin-bottom: 2rem;
  }
`;